module.exports = __webpack_public_path__ + "img/Welding servicies on the oil rig platform.d4c5c8dc.png";